import { MergeScreen } from './MergeScreen';

export const mergeRoute = { path: 'merge/:planId?', element: <MergeScreen /> };
